import PnlAccountList from './PnlAccountList';
import PnlAccountShow from './PnlAccountShow';

export default {
  list: PnlAccountList,
  show: PnlAccountShow,
};
